import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_17794_62925)" }, [
      _createElementVNode("path", {
        d: "M12.75 2.50492C13.8812 3.15806 14.8222 4.09531 15.4799 5.22389C16.1375 6.35248 16.489 7.63325 16.4996 8.93942C16.5101 10.2456 16.1794 11.5319 15.54 12.6709C14.9007 13.81 13.9749 14.7623 12.8544 15.4337C11.7339 16.105 10.4575 16.472 9.15157 16.4985C7.84562 16.5249 6.55541 16.2098 5.40867 15.5844C4.26192 14.9589 3.2984 14.0448 2.6135 12.9326C1.9286 11.8203 1.54606 10.5485 1.50375 9.24292L1.5 8.99992L1.50375 8.75692C1.54575 7.46166 1.92266 6.19939 2.59773 5.09316C3.2728 3.98694 4.22299 3.07451 5.35567 2.44483C6.48835 1.81515 7.76486 1.48972 9.06075 1.50025C10.3566 1.51078 11.6277 1.85692 12.75 2.50492ZM7.88325 6.85492C7.72611 6.76138 7.54021 6.72847 7.36051 6.76239C7.18081 6.79631 7.01969 6.89472 6.90746 7.03911C6.79523 7.18349 6.73962 7.36391 6.75109 7.54642C6.76257 7.72894 6.84033 7.90097 6.96975 8.03017L7.93875 8.99992L6.96975 9.96967L6.9075 10.0402C6.79094 10.1909 6.73613 10.3804 6.7542 10.5701C6.77227 10.7598 6.86187 10.9355 7.00479 11.0615C7.14772 11.1875 7.33325 11.2544 7.52371 11.2486C7.71417 11.2428 7.89528 11.1647 8.03025 11.0302L9 10.0612L9.96975 11.0302L10.0402 11.0924C10.191 11.209 10.3805 11.2638 10.5701 11.2457C10.7598 11.2276 10.9355 11.1381 11.0616 10.9951C11.1876 10.8522 11.2545 10.6667 11.2487 10.4762C11.2429 10.2857 11.1648 10.1046 11.0302 9.96967L10.0612 8.99992L11.0302 8.03017L11.0925 7.95967C11.2091 7.80893 11.2639 7.61947 11.2458 7.42978C11.2277 7.24008 11.1381 7.06438 10.9952 6.93836C10.8523 6.81233 10.6667 6.74543 10.4763 6.75125C10.2858 6.75706 10.1047 6.83516 9.96975 6.96967L9 7.93867L8.03025 6.96967L7.95975 6.90742L7.88325 6.85492Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_17794_62925" }, [
        _createElementVNode("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }